import Collapsible from "components/Collapsible";
import { ScheduleWrapper } from "./styled";

const Header = ({ data }) => {
  return (
    <div className="schedule-header s-18 label-l">
      <div
        className={`medium s-16 text-black word-break py-10`}
      >
        {data.title}
      </div>
    </div>
  );
};

const Schedule = ({
  data,
}) => {
  return (
    <ScheduleWrapper >

      {data?.map((e, key) => (
        <div className="schedule_item" key={key}>
          <Collapsible header={<Header data={e} />}>
            <div
              className="regular label-l s-14 pb-10 mr-20 word-break"
              dangerouslySetInnerHTML={{ __html: e.content }}
            ></div>
          </Collapsible>
        </div>
      ))}
    </ScheduleWrapper>
  );
};

export default Schedule;
